import http from "./http-service"
import QuotationService from "./quotation-service"

export default class DashboardService {

  static getQuotationStatus() {
    return http.get("dashboard/quotation-status")
      .then((response) => {

        let data = []

        response.status.forEach((status) => {
          data.push({
            ...status,
            ...QuotationService.QUOTATION_STATUS[status.id],
          })
        })

        return data
      })
  }

  static getConfirmedQuotations() {
    return http.get("dashboard/confirmed-quotations").then((response) => response.months)
  }

  static getBillingValue() {
    return http.get("dashboard/billing-value").then((response) => response.months)
  }

  static getQuotationsWaitingConfirmation() {
    return http.get("dashboard/quotations-waiting-confirmation").then((response) => response.quotations)
  }
}